import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const StarSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default StarSVG;
